import { EDITING_OPTIONS, ENTITLEMENTS } from '../application-core/constants';
import Positioning from '../core/Positioning';
import InboundToResource from './InboundToResource';
import ResourceVisualisationDialog from '../application-core/visualisation/ResourceVisualisationDialog';
import HistoryViewer from '../core/HistoryViewer';
import { getGraphFromProject } from '../core/utils/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import TripleViewer from '../core/TripleViewer';
import DataOptions from '../core/DataOptions';
import ClassDetail from './ClassDetail';
import ResourceSummaryDetail from './ResourceSummaryDetail';
import { OWL_OBJECT_CONFIGURATION, VIZ_CLASSES } from './constants';

class ClassData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    const { classIRI, onDeleteClass, project, ontologyIRI, buildLink, viewLang, excludeDeprecated, editingOptions, isReadOnly,
      hiddenProps, availableAnnotationProperty, onFoundResource, useWorkflow, entitlements, projectUsers } = this.props;
    const { view } = this.state;
    const projectGraph = getGraphFromProject(project);

    return (
      <ProjectConsumer>
        {({ defaultLang, hasComponent }) => (
          <div>
            <DataOptions
              handleNotAvailable={true}
              id={classIRI}
              graph={projectGraph}
              positioningOption={true}
              inboundOption={true}
              changeView={this.changeView}
              view={this.state.view}
              historyOption={true} />
            <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
              <ResourceSummaryDetail
                handleNotAvailable={true}
                allowIRIchange={false}
                viewLang={viewLang}
                id={classIRI}
                useWorkflow={useWorkflow}
                canPun={editingOptions && editingOptions.includes(EDITING_OPTIONS.PUNNING)}
                component={ontologyIRI}
                canDeprecate={true}
                isReadOnly={isReadOnly}
                graph={projectGraph}
                defaultLang={defaultLang}
                onDeleteResource={onDeleteClass}
                additionalViews={
                  <ResourceVisualisationDialog
                    defaultLang={defaultLang}
                    objectPropertyConfiguration={OWL_OBJECT_CONFIGURATION}
                    displayClasses={VIZ_CLASSES}
                    viewLang={viewLang}
                    sourceNode={classIRI}
                    graph={projectGraph} />
                }
                permission="https://grafsync.graphifi.com/schema/om-entitlement/editOntology" />
              {view === 0 &&
                <ClassDetail
                  useWorkflow={useWorkflow}
                  projectUsers={projectUsers}
                  handleNotAvailable={true}
                  graph={projectGraph}
                  viewLang={viewLang}
                  expectedTypes={["OwlClass"]}
                  excludeDeprecated={excludeDeprecated}
                  editingOptions={editingOptions}
                  entitlements={entitlements}
                  hiddenProps={hiddenProps}
                  defaultLang={defaultLang}
                  availableAnnotationProperty={availableAnnotationProperty}
                  ontologyIRI={ontologyIRI}
                  buildLink={buildLink}
                  project={project}
                  id={classIRI} />}
              {view === 1 &&
                <TripleViewer
                  requiredEntitlement={ENTITLEMENTS.EDIT_ONTOLOGY}
                  handleNotAvailable={true}
                  deletionOverrides={[
                    "http://www.w3.org/2002/07/owl#sameAs",
                    "http://www.w3.org/2002/07/owl#differentFrom",
                    "http://www.w3.org/2002/07/owl#equivalentProperty"
                  ]}
                  id={classIRI}
                  graph={projectGraph} />}
              {view === 4 &&
                <HistoryViewer handleNotAvailable={true} id={classIRI} graph={projectGraph} />}
              {view === 8 &&
                <Positioning
                  displayType="Class"
                  id={classIRI}
                  components={hasComponent}
                  handleNotAvailable={true}
                  onFoundResource={onFoundResource}
                  componentIRI={ontologyIRI}
                  projectIRI={project}
                  path="http://www.w3.org/2000/01/rdf-schema#subClassOf"
                  defaultLang={defaultLang}
                  viewLang={viewLang}
                  graph={projectGraph} />
              }
              {view === 9 &&
                <InboundToResource
                  id={classIRI}
                  components={hasComponent}
                  handleNotAvailable={true}
                  componentIRI={ontologyIRI}
                  projectIRI={project}
                  defaultLang={defaultLang}
                  viewLang={viewLang}
                  graph={projectGraph} />
              }
            </div>
          </div>
        )}
      </ProjectConsumer>
    );
  }

}

ClassData.propTypes = {
  buildLink: PropTypes.func.isRequired,
  project: PropTypes.string.isRequired,
  classIRI: PropTypes.string.isRequired,
  entitlements: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool,
  projectUsers: PropTypes.array,
  viewLang: PropTypes.string,
  excludeDeprecated: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  hiddenProps: PropTypes.array,
  editingOptions: PropTypes.array,
  onFoundResource: PropTypes.func.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  onDeleteClass: PropTypes.func.isRequired,
  availableAnnotationProperty: PropTypes.array
};

export default ClassData;